import { List } from "immutable";
import { createSelector } from "reselect";
import i18n from "~/i18n";

const getAccountBalance = (state = {}) => state.accountBalance || {};

const returnBalanceAsFloatValue = (value) => parseFloat(value) || 0;

export const getAmountAvailable = createSelector(
  (state) => getAccountBalance(state).amountAvailable,
  returnBalanceAsFloatValue
);

export const getSubscriptionBalance = createSelector(
  (state) => getAccountBalance(state).subscriptionBalance,
  returnBalanceAsFloatValue
);

export const getRecordedBalance = createSelector(
  (state) => getAccountBalance(state).recordedBalance,
  returnBalanceAsFloatValue
);

export const getRecords = createSelector(
  (state) => getAccountBalance(state).records,
  (records) => {
    if (Array.isArray(records)) {
      return records;
    } else if (List.isList(records)) {
      return records.toJS();
    }

    return [];
  }
);

export const getCombinedRecords = createSelector(getRecords, getSubscriptionBalance, (records, subscriptionBalance) => {
  let newRecord = {
    amount: subscriptionBalance,
    amount_available: subscriptionBalance,
    reason: i18n.t("Previous plan refund"),
    reason_details: ``,
  };

  return subscriptionBalance > 0 ? [newRecord, ...records] : records;
});
